import React from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"

const Button = ({
  label,
  href,
  icon,
  className,
  accessibility_title,
  target,
  button_color,
  AB_button_cta,
  AB_button_cta_mobile,
}) => (
  <a
    className={[
      "btn",
      className,
      button_color ? "btn--color" : "",
      AB_button_cta ? "btn--cta" : "",
      AB_button_cta_mobile ? "btn--cta--mobile" : "",
    ].join(" ")}
    href={href}
    title={accessibility_title || label}
    target={target}
  >
    <span className="btn__text">{label}</span>
    {icon && Icon[icon] && (
      <i className="btn__icon">
        {React.createElement(Icon[icon], {
          className: "icon icon--sm",
        })}
      </i>
    )}
  </a>
)

Button.defaultProps = {
  label: "",
  className: "",
  icon: "",
  href: "#",
  accessibility_title: "",
  button_color: false,
  AB_button_cta: false,
  AB_button_cta_mobile: false,
}

Button.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  href: PropTypes.string,
  accessibility_title: PropTypes.string,
  target: PropTypes.string,
  button_color: PropTypes.bool,
  AB_button_cta: PropTypes.bool,
  AB_button_cta_mobile: PropTypes.bool,
}

export default Button
